// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__JZCSk","inverted":"Heading_inverted__DAV0W"};